import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IModulesProps } from "us.common/components/Menu/MegaMenu/interface";
import { ConfigurationContext } from "us.common/ConfigurationContext/ConfigurationProvider";
import { reorderMenuItems } from "../../Functions";

const Modules: React.FC<IModulesProps> = React.memo(
  ({ selectedModule, onSelectModule }) => {
    const context = useContext(ConfigurationContext);
    const { t } = useTranslation();

    const features = useMemo(() => {
      return reorderMenuItems(context?.configurationDetail);
    }, [context?.configurationDetail]);

    /**
     * Converts a display name string into a translation key and retrieves the corresponding translation.
     *
     * The function trims the input string, replaces spaces with underscores, and converts it to uppercase
     * to form a translation key. It then uses the `t` function to fetch the translation from the
     * `US.COMMON:MENU` namespace. If the conversion fails or the key is invalid, it returns the original display name.
     *
     * @param displayName - The display name to convert into a translation key.
     * @returns The translated string if the key is valid and found; otherwise, returns the original display name.
     */
    const convertToTranslationKey = (displayName: string) => {
      try {
        const key = displayName?.trim().split(" ").join("_").toUpperCase();
        if (key) {
          return t(`US.COMMON:MENU.${key}`);
        }
        return displayName;
      } catch (error) {
        console.error(
          `Error converting ${displayName} to translation key:`,
          error
        );
        return displayName;
      }
    };

    return (
      <div className="mt-3 module-menu-wrapper">
        {features?.map(
          (module: { id: number; displayName: string; icon: string }) => {
            const { id, displayName, icon } = module;
            return (
              <a
                key={id}
                onClick={() => onSelectModule(module)}
                className={`d-flex align-items-center justify-content-start ${
                  id === selectedModule?.id ? "active" : ""
                }`}
              >
                <span className="module-icon-outer">
                  <img src={icon} />
                </span>
                <span>{convertToTranslationKey(displayName)}</span>
              </a>
            );
          }
        )}
      </div>
    );
  }
);

export default Modules;
